module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-b7f50ca9.png";